import { FC } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import { Box, FormLabel, Typography } from '@mui/material';
import { Tag } from '../../store/slices/tagsSlice';

import styles from './CustomMultiselect.module.scss';

type CustomMultiselectProps = {
  tags: Tag[] | null;
  tagsOptions: Tag[] | null;
  setTagsOptions: (tags: Tag[]) => void;
}

const CustomMultiselect: FC<CustomMultiselectProps> = ({ tags, tagsOptions, setTagsOptions }) => {

  return (
    <Box id={styles.customSelectContainer}>
      <FormLabel className={styles.customSelectLabel}>
        <Typography variant='h11Semibold'>Tags</Typography>
      </FormLabel>
      <Autocomplete
        multiple
        options={tags || []}
        getOptionLabel={(option) => option.name}
        value={tagsOptions || undefined}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        className={styles.customInput}
        onChange={(_, tags: Tag[]) => setTagsOptions(tags)}
        renderTags={(value: readonly Tag[], getTagProps) =>
          value.map((option: Tag, index: number) => {
            const tagProps = getTagProps({ index });
            const { key, ...rest } = tagProps;
            return (
              <Chip
                key={key}
                variant="filled"
                label={option.name}
                {...rest}
                style={{
                  backgroundColor: option.color || '#E0E0E0',
                  padding: 0,
                }}
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label=""
            placeholder="Documents..."
          />
        )}
        style={{ maxWidth: 500, width: '100%' }}
      />
    </Box>
  )
}

export default CustomMultiselect;
